import { MapPin, Clock } from "lucide-react";
import { Link } from "react-router-dom";

const DEFAULT_FOOTER = {
  blurb:
    "Born in a two-stoplight town on Route 66. Every jar is packed by hand, steeped for 21 days, and snaps like it means it.",
  stamp: "WELLSTON, OK",
  address1: "208 N Route 66",
  address2: "Wellston, OK 74881",
  address3: "35.6923° N, 97.0645° W",
  hours1: "Thu – Sat: 9am – 6pm",
  hours2: "Sunday: 10am – 2pm",
  hours3: "Local delivery across Lincoln County",
};

export const Footer = ({ content }) => {
  const c = { ...DEFAULT_FOOTER, ...(content || {}) };
  return (
    <footer id="find-us" className="bg-dill-deep text-parchment overflow-hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-8">
        <p
          className="font-serif font-black text-[9vw] lg:text-[5rem] leading-none text-outline-cream whitespace-nowrap select-none text-center"
          aria-hidden="true"
          data-testid="footer-stamp-text"
        >
          {c.stamp}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-10 text-center">
          <div>
            <div className="flex items-center justify-center gap-2.5 mb-3">
              <img src="/logo.png" alt="Pickle Me OK! logo" className="w-9 h-9 rounded-full object-cover ring-2 ring-parchment/20" />
              <span className="font-serif font-black text-base">
                Pickle Me <span className="text-gold">OK!</span>
              </span>
            </div>
            <p className="text-sm text-parchment/60 leading-relaxed max-w-xs mx-auto">{c.blurb}</p>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold mb-3">The Farmstand</p>
            <div className="flex items-start justify-center gap-2 text-sm text-parchment/70">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-terra" />
              <span className="text-center">
                {c.address1}
                <br />
                {c.address2}
                {c.address3 && (
                  <>
                    <br />
                    <span className="font-mono text-xs text-parchment/40">{c.address3}</span>
                  </>
                )}
              </span>
            </div>
          </div>

          {(c.hours1 || c.hours2 || c.hours3) && (
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold mb-3">Pickup Hours</p>
              <div className="flex items-start justify-center gap-2 text-sm text-parchment/70">
                <Clock className="w-4 h-4 mt-0.5 shrink-0 text-terra" />
                <span className="text-center">
                  {[c.hours1, c.hours2, c.hours3]
                    .filter(Boolean)
                    .map((line, i, arr) => (
                      <span key={i}>
                        {line}
                        {i < arr.length - 1 && <br />}
                      </span>
                    ))}
                </span>
              </div>
            </div>
          )}
        </div>

        <div className="mt-10 pt-5 border-t border-parchment/10 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-8">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-parchment/35">
            © {new Date().getFullYear()} Pickle Me OK!
          </p>
          <Link
            to="/admin"
            className="font-mono text-[10px] uppercase tracking-[0.25em] text-parchment/35 hover:text-gold transition-colors"
            data-testid="footer-admin-link"
          >
            Owner Pantry Portal
          </Link>
        </div>
      </div>
    </footer>
  );
};
